module.exports = __webpack_public_path__ + "static/media/9.4646678f.jpg";